import { render } from "./richArticle.vue?vue&type=template&id=396b1092&scoped=true"
import script from "./richArticle.vue?vue&type=script&lang=js"
export * from "./richArticle.vue?vue&type=script&lang=js"

import "./richArticle.vue?vue&type=style&index=0&id=396b1092&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396b1092"]])

export default __exports__